import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";
const UpdateDataContext = createContext();

export const UpdateDataProvider = ({ children, initialState = {} }) => {
  const [workflow, setWorkflow] = useState(
    initialState.workflow || localStorage.getItem("workflow")
  );
  const [templateData, setTemplateData] = useState({
    name: "",
    created: "",
    template: {},
    problems: [],
    use: "general",
    ...initialState.templateData,
  });

  const [templateNames, setTemplateNames] = useState(null);

  const [affiliateFileData, setAffiliateFileData] = useState({
    name: "",
    created: "",
    columns: [],
    size: 0,
    ...initialState.affiliateFileData,
  });

  const [politicalData, setPoliticalData] = useState({
    dataSource: null,
    eventName: null,
    eventDate: null,
    columns: [],
    fileName: null,
    fileCreated: null,
    affiliate: null,
    ...initialState.politicalData,
  });

  const [summaryData, setSummaryData] = useState({
    summary: {},
    processTimestamp: "",
    processedFileAffiliate: "",
    processedDuration: 0,
    droppedRows: null,
    fullPath: "",
    ...initialState.summaryData,
  });

  const handleTemplateDataChange = (updates) => {
    setTemplateData((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  const handleTemplateNamesChange = (updates) => {
    setTemplateNames((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  const handleAffiliateFileDataChange = (updates) => {
    setAffiliateFileData((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  const handlePoliticalDataChange = (updates) => {
    setPoliticalData((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  const handleSummaryDataChange = (updates) => {
    setSummaryData((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  const handleWorkflowChange = (workflow) => {
    localStorage.setItem("workflow", workflow);
    setWorkflow(workflow);
  };

  const resetContext = () => {
    handleAffiliateFileDataChange({
      name: "",
      created: "",
      columns: [],
      size: 0,
    });
    handleTemplateDataChange({
      name: "",
      created: "",
      template: {},
      problems: [],
      use: workflow === "political" ? "political" : "general",
    });
    handlePoliticalDataChange({
      dataSource: null,
      category: null,
      eventName: null,
      eventDate: null,
      columns: [],
      fileName: null,
      fileCreated: null,
    });
  };

  return (
    <UpdateDataContext.Provider
      value={{
        templateData,
        handleTemplateDataChange,
        templateNames,
        handleTemplateNamesChange,
        affiliateFileData,
        handleAffiliateFileDataChange,
        politicalData,
        handlePoliticalDataChange,
        summaryData,
        handleSummaryDataChange,
        workflow,
        handleWorkflowChange,
        resetContext,
      }}
    >
      {children}
    </UpdateDataContext.Provider>
  );
};

UpdateDataProvider.propTypes = {
  children: PropTypes.element,
};

export const useUpdateDataContext = () => {
  return useContext(UpdateDataContext);
};
